import React from 'react';

import {AutosuggestItem, AutosuggestNoResults} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import Loading from '@pb/kit-component-loading';
import Typography from '@pb/kit-component-typography';

import type {Grant} from 'src/openapi/admin/models/Grant';

type Props = {
    id: string,
    busy: boolean,
    grants: Grant[],
    hasSearched?: boolean,
    isMinQueryShown?: boolean,
};

const MIN_QUERY_MESSAGE = 'The search query is less than the minimum allowed, continue typing...';

export const GrantSuggestList: React.FC<Props> = ({id, busy, grants, hasSearched = false, isMinQueryShown = false}) => {
    if (busy) {
        return (
            <div id={id} style={{padding: 8, display: 'flex', alignItems: 'center', gap: 8}}>
                <Loading type="ICON"/> <Typography>Loading</Typography>
            </div>
        );
    }

    if (isMinQueryShown) {
        return (
            <Typography style={{padding: 8}}>{MIN_QUERY_MESSAGE}</Typography>
        );
    }

    if (Array.isArray(grants) && grants.length > 0) {
        return (
            <div id={id}>
                {grants.map(grant => (
                    <AutosuggestItem
                        key={grant.grantId}
                        value={grant}
                        caption={(
                            <div>
                                <EllipsisTextHint title={grant.grantName}>
                                    {grant.grantName}
                                </EllipsisTextHint>
                            </div>
                        )}
                    />
                ))}
            </div>
        );
    }

    if (hasSearched) {
        return <AutosuggestNoResults/>;
    }

    return (
        <Typography style={{padding: 8}}>
            There are no available grants
        </Typography>
    );
};
